/*
  <button type="button" [btnLoading]="icon.recargando" [color]="'red'" [disable_btn]='false' [hidden_content]='false'>
    <span i18n>Recargar</span>
  </button>
*/

import { Directive, input, effect, ElementRef, Renderer2, inject } from '@angular/core';

@Directive({
  selector: '[btnLoading]',
  standalone: true
})
export class BtnLoadingDirective {
  // Nueva sintaxis de Signal Input (Angular 21)
  btnLoading = input<boolean>(false);
  
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  constructor() {
    // Los 'effects' son la forma moderna de reaccionar a cambios en Signals
    effect(() => {
      const isLoading = this.btnLoading();
      const button = this.el.nativeElement;

      if (isLoading) {
        this.renderer.addClass(button, 'is-loading');
        this.renderer.setAttribute(button, 'disabled', 'true');
        // Aquí podrías insertar tu spinner dinámicamente
      } else {
        this.renderer.removeClass(button, 'is-loading');
        this.renderer.removeAttribute(button, 'disabled');
      }
    });
  }
}